import type { FormikProps } from 'formik';

import type { ClientFormValues } from '../models/Forms';

export async function isIdentificationNumberValidForRegistryCheck(
  formik: FormikProps<ClientFormValues>,
): Promise<boolean> {
  await formik.validateField('identificationNumber');
  const fieldError = formik.errors.identificationNumber;
  if (fieldError) {
    void formik.setFieldTouched('identificationNumber', true, false);
    return false;
  }
  return true;
}
